(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserProfileV2Controller', UserProfileV2Controller);

    UserProfileV2Controller.$inject = ['PersonInfo', 'UserProfileQuery', 'LocationInfo', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', 'entity', '$rootScope','LegalActualInfoService'];

    function UserProfileV2Controller(PersonInfo, UserProfileQuery, LocationInfo, $translate, $scope, SelectorData, SelectorDataQuery, entity, $rootScope, LegalActualInfoService) {
        var vm = this;
        vm.personInfo = entity;
        vm.legalInfo = {}
        vm.accid = null;
        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.success = true;
        vm.selectordata = SelectorData.query();
        vm.blockEditPhoneNumber = true;

        vm.closeModal = closeModal;
        vm.okModal = okModal;

        loadData()

        function save() {
            //
            vm.isSaving = true;

            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                // ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:userProfileUpdate', result);
            vm.personInfo = result;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();
            $rootScope.modalInstance.dismiss('cancel');
        }
          function loadData(){
            const res = LegalActualInfoService.fetchInfo().query()
            vm.legalInfo = res
        }

    }
})();
